module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgB7ZRBDoIwEEX/GNx7hHIHTezSk3gUOYKcyJ0lkTvYI7B3UdumTRCG0hhMXPATaBPmv7T9Q4EMNap9uientkCeRGYdNlhYK/APgaO2if1m8DpJKTVnUkoJwvbm5ke5L5GxQm9wxgRMcMYR0K3MDpqDDmA61H6IkN6SiPDwSfdh3JGwQAbal06d7yRwApqEeWBMdZgWA00mHzkFZm6SACgxL+FeP/hTDDo34XouV9FLhI6UelQEumAJGdQ+5ebeXu1wtpnv8I3sLg2ZWspD9QYRnWU0IUp9OAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.png
// module id = 659
// module chunks = 1